export default __webpack_public_path__ + "static/media/dodatki_skrobiowe.471441e0.svg";